// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1156c1e","453":"9e6e48f6","455":"caeb85fb","977":"d03fa864"}[chunkId] + ".chunk.js";
};